import { defineType } from 'sanity'
import getPageInfo, { seoGroup } from '../../objects/pageInfo'

export default defineType({
  name: 'blogHome',
  title: 'Blog Home',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [getPageInfo({ lockCanonical: true })],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare({ pageInfo }) {
      const { title = 'New Page' } = pageInfo || {}
      return {
        title,
        subtitle: 'Blog Homepage',
      }
    },
  },
})